// src/pages/AiInterviewScores.js
import React, { useState, useEffect, useMemo } from "react";
import { Checkbox } from "@carbon/react";
import InterviewChartRecent from "../components/InterviewChartRecent";
import api from "../api";
import { useAuth } from "../auth/AuthContext";

// === 9カテゴリ → qid のマッピング ===============================
const CATEGORY_TO_QIDS = {
  "歩行機能": ["msws1", "msws2", "msws3"],
  "上肢機能": ["amsq"],
  "疲労（認知）": ["mfis_cog"],
  "疲労（身体動作）": ["mfis_phy"],
  "疲労（社会性）": ["mfis_soc"],
  "高次脳機能（情報処理速度）": ["msnq_att"],
  "高次脳機能（記憶）": ["msnq_mem"],
  "高次脳機能（その他活動）": ["msnq_other"],
  "高次脳機能（人格・行動）": ["msnq_pb"],
};

const RECENT_GROUP_OPTIONS = Object.keys(CATEGORY_TO_QIDS);

// === メイン =======================================================
export default function AiInterviewScores() {
  const { user, role } = useAuth() || {};
  const storedPatient = sessionStorage.getItem("patient");
  const patient = storedPatient ? JSON.parse(storedPatient) : null;
  const research_id = patient?.research_id || user?.id || "P010";
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedLabels, setSelectedLabels] = useState(RECENT_GROUP_OPTIONS);

  // === チェックボックス制御 ===
  const toggleGroup = (label) => {
    setSelectedLabels((prev) =>
      prev.includes(label)
        ? prev.filter((l) => l !== label)
        : [...prev, label]
    );
  };

  // === QIDの抽出 ===
  const selectedQids = useMemo(() => {
    const set = new Set();
    selectedLabels.forEach((label) => {
      (CATEGORY_TO_QIDS[label] || []).forEach((q) => set.add(q));
    });
    return Array.from(set);
  }, [selectedLabels]);

  // === API呼び出し ===
  useEffect(() => {
    if (!user?.id) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/v1/doctor/doctor_dashboard/${research_id}`);
        if (res.status === 200) {
          setApiData(res.data);
          console.log("✅ doctor_dashboard:", res.data);
        }
      } catch (err) {
        console.error("doctor_dashboard エラー:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user?.id]);

  // === 歩行機能の平均線を出すか ===
  const selectedGroups = useMemo(() => {
    const groups = [];
    const hasWalking = selectedQids.some((q) =>
      ["msws1", "msws2", "msws3"].includes(q)
    );
    if (hasWalking) groups.push("歩行機能");
    return groups;
  }, [selectedQids]);

  // === レンダリング ===
  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
      }}
    >
      <h1>AI問診スコア（時系列）</h1>

      {/* ✅ カテゴリ選択UI */}
      <section style={{ flex: 1, minWidth: "300px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          {RECENT_GROUP_OPTIONS.map((label) => (
            <Checkbox
              key={label}
              id={label}
              labelText={label}
              checked={selectedLabels.includes(label)}
              onChange={() => toggleGroup(label)}
            />
          ))}
        </div>

        {loading && <p>読み込み中...</p>}
        {!loading && apiData && (
          <InterviewChartRecent
            apiData={apiData}
            selectedGroups={selectedGroups}
            selectedQids={selectedQids}
          />
        )}
      </section>
    </div>
  );
}
